// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tsd5","productName":"Table_productName__3jSxd"};